import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props}>
    <defs>
      <clipPath id="a">
        <path
          data-name="Rectangle 2449"
          transform="translate(-.25 -.25)"
          fill="none"
          d="M0 0h20v20H0z"
        />
      </clipPath>
      <clipPath id="b">
        <path
          data-name="Path 7766"
          d="M-35.02-8.913-30.121-2l-1.038.535L-29.714.58l-1.445 1.559 4.878 6.887-14.381 1.058-2.418-14.817 3.205-8.467Z"
          transform="translate(43.08 13.2)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g data-name="New 20" transform="translate(.25 .25)" clipPath="url(#a)">
      <g data-name="Group 6378">
        <path data-name="Rectangle 2448" fill="#fff" d="M7.342 4.547h4.173v10.765H7.342z" />
        <path
          data-name="Icon material-new-releases"
          d="m19.661 9.758-2.2-2.5.306-3.312-3.246-.736-1.7-2.862-3.06 1.31-3.06-1.31-1.7 2.862-3.249.729.306 3.312-2.197 2.507 2.2 2.5-.31 3.327L5 16.323l1.7 2.862 3.061-1.327 3.06 1.314 1.7-2.862 3.249-.738-.306-3.312 2.2-2.5Zm-9 4.5h-1.8v-1.8h1.8Zm0-3.6h-1.8v-5.4h1.8Z"
          fill="#ff3c00"
        />
        <g data-name="Group 6377" clipPath="url(#b)" transform="translate(-3.06 -1.078)">
          <path
            data-name="Icon material-new-releases"
            d="m22.721 10.836-2.2-2.5.306-3.312-3.246-.736-1.7-2.862-3.06 1.31-3.06-1.31-1.7 2.862-3.249.729.306 3.312-2.197 2.507 2.2 2.5-.31 3.327 3.249.738 1.7 2.862 3.061-1.327 3.06 1.314 1.7-2.862 3.249-.738-.306-3.312 2.2-2.5Zm-9 4.5h-1.8v-1.8h1.8Zm0-3.6h-1.8v-5.4h1.8Z"
            fill="#ff7300"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgComponent;
